import React from "react";
import { Cards } from "../Cards";
import { usePlans } from "@/hooks/usePlans";
import { useAccessibility } from "@/hooks/useAccessibility";
import { Container, Button, ResultsWrapper } from "./styles";
import { ErrorSearchPlans } from "@/components/global/Errors/SearchPlans";
import { CachedFilled } from "@/components/global/svgs/plans/cachedFilled";
import { useFloatingFilterButton } from "@/services/zustand/flotingFilterButton";
import Skeleton from "@mui/material/Skeleton";

export const ArrayPlans: React.FC = () => {
  const {
    plans,
    isLoading,
    pagePlans,
    isResearch,
    totalPlans,
    setPagePlans,
    handleLoadMore,
    searchJsonTerms,
    SearchPlansError,
  } = usePlans();
  const { fontSizeIncreased } = useAccessibility();
  const floatingIsOpen = useFloatingFilterButton(state => state.open);

  if (SearchPlansError) {
    return (
      <ErrorSearchPlans/>
    );
  }

  return (
    <>
      {
        isLoading && Object.keys(searchJsonTerms).length > 0 && (
          <ResultsWrapper>
            <div className="results" style={{ display: "flex" }}>
              <Skeleton variant="rectangular" width={340} height={40} />
            </div>
          </ResultsWrapper>
        )
      }
      {isResearch && !isLoading && (
        <ResultsWrapper>
          <div className="results" style={{ display: "flex" }}>
            <p className="resizeable-accessibility">Resultados da busca:</p>
            <span className="resizeable-accessibility">{plans?.length}</span>
          </div>
        </ResultsWrapper>
      )}

      <Container filterIsOpen={floatingIsOpen} isIncrease={fontSizeIncreased}>
        <Cards />
      </Container>
      {plans?.length > 0 && (
        <>
          {plans?.length < totalPlans && !isResearch && (
            <Button
              onClick={() => {
                setPagePlans((prev: any) => prev + 1);
                handleLoadMore(pagePlans);
              }}
            >
              <h1 className="resizeable-accessibility">Carregar mais</h1>
              <CachedFilled />
            </Button>
          )}
        </>
      )}
    </>
  );
};
